import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';
import StatusBadge from '../../components/admin/StatusBadge';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function Subscriptions() {
  const columns = useMemo(() => [
    { field: 'orgName', headerName: 'Organization', minWidth: 180 },
    { field: 'ownerName', headerName: 'Owner' },
    { field: 'ownerEmail', headerName: 'Email', minWidth: 200 },
    { field: 'paddleSubscriptionId', headerName: 'Subscription ID' },
    { field: 'status', headerName: 'Status', cellRenderer: StatusBadge, minWidth: 120 },
    { field: 'billingCycle', headerName: 'Billing Cycle' },
    { field: 'trialStart', headerName: 'Trial Start', valueFormatter: fmtDate },
    { field: 'trialEnd', headerName: 'Trial End', valueFormatter: fmtDate },
    { field: 'currentPeriodStart', headerName: 'Period Start', valueFormatter: fmtDate },
    { field: 'currentPeriodEnd', headerName: 'Period End', valueFormatter: fmtDate },
    { field: 'gracePeriodDays', headerName: 'Grace Days', filter: 'agNumberColumnFilter' },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getSubscriptions({ page: 0, size: 10000 });
    return res.content || [];
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Subscriptions</h1>
      <AdminGrid columns={columns} fetchData={fetchData} />
    </div>
  );
}
